"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _resources = require("./resources");
Object.keys(_resources).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resources[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _resources[key];
    }
  });
});
var _AppNames = require("./AppNames");
Object.keys(_AppNames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppNames[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AppNames[key];
    }
  });
});
var _Banners = require("./Banners");
Object.keys(_Banners).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Banners[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Banners[key];
    }
  });
});
var _BroadcastTypes = require("./BroadcastTypes");
Object.keys(_BroadcastTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BroadcastTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BroadcastTypes[key];
    }
  });
});
var _DisplaySurfaceTypes = require("./DisplaySurfaceTypes");
Object.keys(_DisplaySurfaceTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DisplaySurfaceTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DisplaySurfaceTypes[key];
    }
  });
});
var _EnvironmentTypes = require("./EnvironmentTypes");
Object.keys(_EnvironmentTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnvironmentTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _EnvironmentTypes[key];
    }
  });
});
var _Knocks = require("./Knocks");
Object.keys(_Knocks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Knocks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Knocks[key];
    }
  });
});
var _LayerPositions = require("./LayerPositions");
Object.keys(_LayerPositions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayerPositions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LayerPositions[key];
    }
  });
});
var _LocalStorageKeys = require("./LocalStorageKeys");
Object.keys(_LocalStorageKeys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LocalStorageKeys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LocalStorageKeys[key];
    }
  });
});
var _MediaPlayer = require("./MediaPlayer");
Object.keys(_MediaPlayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MediaPlayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MediaPlayer[key];
    }
  });
});
var _ModalTypes = require("./ModalTypes");
Object.keys(_ModalTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModalTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ModalTypes[key];
    }
  });
});
var _NetworkHealth = require("./NetworkHealth");
Object.keys(_NetworkHealth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NetworkHealth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NetworkHealth[key];
    }
  });
});
var _SceneLayouts = require("./SceneLayouts");
Object.keys(_SceneLayouts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SceneLayouts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SceneLayouts[key];
    }
  });
});
var _Sessions = require("./Sessions");
Object.keys(_Sessions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Sessions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Sessions[key];
    }
  });
});
var _SocketEvents = require("./SocketEvents");
Object.keys(_SocketEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocketEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SocketEvents[key];
    }
  });
});
var _Sources = require("./Sources");
Object.keys(_Sources).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Sources[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Sources[key];
    }
  });
});
var _Timeout = require("./Timeout");
Object.keys(_Timeout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Timeout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Timeout[key];
    }
  });
});
var _UploadStatus = require("./UploadStatus");
Object.keys(_UploadStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UploadStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _UploadStatus[key];
    }
  });
});
var _ReadinessCheck = require("./ReadinessCheck");
Object.keys(_ReadinessCheck).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReadinessCheck[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ReadinessCheck[key];
    }
  });
});
var _Views = require("./Views");
Object.keys(_Views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Views[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Views[key];
    }
  });
});
var _SourceRoleTypes = require("./SourceRoleTypes");
Object.keys(_SourceRoleTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SourceRoleTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SourceRoleTypes[key];
    }
  });
});
var _SourceLoadStatus = require("./SourceLoadStatus");
Object.keys(_SourceLoadStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SourceLoadStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SourceLoadStatus[key];
    }
  });
});
var _Upload = require("./Upload");
Object.keys(_Upload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Upload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Upload[key];
    }
  });
});
var _Branding = require("./Branding");
Object.keys(_Branding).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Branding[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Branding[key];
    }
  });
});
var _NotificationErrors = require("./NotificationErrors");
Object.keys(_NotificationErrors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationErrors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NotificationErrors[key];
    }
  });
});
var _Background = require("./Background");
Object.keys(_Background).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Background[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Background[key];
    }
  });
});
var _Overlays = require("./Overlays");
Object.keys(_Overlays).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Overlays[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Overlays[key];
    }
  });
});
var _MediaStatus = require("./MediaStatus");
Object.keys(_MediaStatus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MediaStatus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MediaStatus[key];
    }
  });
});
var _ActiveSpeakerInSession = require("./ActiveSpeakerInSession");
Object.keys(_ActiveSpeakerInSession).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActiveSpeakerInSession[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActiveSpeakerInSession[key];
    }
  });
});
var _VirtualBackground = require("./VirtualBackground");
Object.keys(_VirtualBackground).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _VirtualBackground[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _VirtualBackground[key];
    }
  });
});
var _Meeting = require("./Meeting");
Object.keys(_Meeting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Meeting[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Meeting[key];
    }
  });
});